module.exports = __webpack_public_path__ + "img/logo.15e24c7c.png";